export default __webpack_public_path__ + "static/media/github.8b91b41b.svg";